import { categories } from '@/mocks/movies';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-heading text-background-50">
                  番茄影视
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                番茄影视大全，一站式汇聚海量影视资源。高清画质流畅不卡顿，免费在线观看最新热播剧集和经典大片。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="/category/movie" className="hover:text-primary-400 transition-colors cursor-pointer">影视分类</a>
              </h4>
              <ul className="space-y-2">
                {categories.filter((c) => c.slug !== 'all').map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="/about#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    联系我们
                  </a>
                </li>
                <li>
                  <a href="/about#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    常见问题
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系番茄影视</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@fanqieyingshi.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-123-4567</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市朝阳区</span>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="https://weibo.com" target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-background-50 text-sm"></i>
                </a>
                <a href="https://www.douban.com" target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-douban-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-background-50 text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 番茄影视 版权所有 | 京ICP备XXXXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}